<div class="p-6">
    <div class="mb-6">
        <h2 class="text-xl font-semibold text-foreground">{{ 'Change Password' | translate }}</h2>
        <p class="mt-1 text-sm text-foreground/70">
            {{ 'Please enter your current password and choose a new one' | translate }}
        </p>
    </div>

    <form class="flex flex-col gap-4">
        <app-text-input
            label="Old Password"
            id="oldPassword"
            placeholder="Enter old password"
            [password]="true"
            [isRequired]="true"
            [isEditMode]="true"
            [(value)]="oldPassword" />

        <app-text-input
            label="New Password"
            id="newPassword"
            placeholder="Enter new password"
            [password]="true"
            [passwordConditions]="true"
            [isRequired]="true"
            [isEditMode]="true"
            [(value)]="newPassword" />

        <app-text-input
            label="Repeat New Password"
            id="repeatNewPassword"
            placeholder="Repeat new password"
            [password]="true"
            [isRequired]="true"
            [isEditMode]="true"
            [(value)]="repeatNewPassword" />
        @if (!passwordsMatch) {
            <p class="mt-1 text-sm text-danger">{{ 'Passwords do not match' | translate }}</p>
        }
    </form>

    <div class="mt-8 flex justify-end gap-3">
        <button
            class="rounded-md border border-input bg-background px-4 py-2 text-sm font-medium text-foreground hover:bg-accent focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50"
            type="button"
            [disabled]="isSubmitting()"
            (click)="cancel()">
            {{ 'Cancel' | translate }}
        </button>
        <button
            class="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            type="button"
            [disabled]="!canConfirm"
            (click)="confirm()">
            @if (isSubmitting()) {
                {{ 'Changing...' | translate }}
            } @else {
                {{ 'Change Password' | translate }}
            }
        </button>
    </div>
</div>
